import * as React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import searchStyles from './searchStyles';

interface ActionLogsTableSearchProps {
  value: string;
  onChange: (query: string) => void;
}

export default function ActionLogsTableSearch(props: ActionLogsTableSearchProps) {
  const { value, onChange } = props;

  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <TextField
      label="Search..."
      size="small"
      value={value}
      sx={searchStyles.textField}
      onChange={handleSearchInput}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon color="action" fontSize="small" />
          </InputAdornment>
        ),
      }}
    />
  );
}
